// RedirectToLogin.tsx
import { Navigate, useLocation } from 'react-router-dom';

export function RedirectToLogin() {
    const { pathname } = useLocation();

    return <Navigate to={`/login?redirect=${encodeURIComponent(pathname)}`} replace />;
}